import { useContext, useRef, useState } from 'react'
import Modal from 'react-modal'
import itemCategoryList from '@/resources/itemCategory.json'
import itemListJson from '@/resources/itemShop.json'
import { SelectedItemContext } from '@/App'

type Props = {
  isOpen: boolean
  closeModal: () => void
  editUuid: string
}
const EditItemListModal = ({ isOpen, closeModal, editUuid }: Props) => {
  // #region フック
  const selectedItem = useContext(SelectedItemContext)

  const [, dispatch] = useState({})

  const category = useRef(0)

  const editItem = selectedItem.shopItemList.find((s) => s.uuid === editUuid)

  // #endregion フック

  // #region スタイル

  const modalStyle: Modal.Styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute',
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      top: '15%',
      left: '35%',
      right: '35%',
      bottom: '25%',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 0px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '10px 10px 10px 50px'
  }

  const pulldownStyle: React.CSSProperties = {
    fontSize: '15px',
    height: '24px'
  }

  const targetFormsStyle: React.CSSProperties = {
    height: '335px',
    margin: '10px 25px auto auto',
    backgroundColor: '#FFFFFF',
    border: 'solid 1px',
    overflowY: 'scroll'
  }

  const textBoxStyle: React.CSSProperties = {
    height: '20px',
    margin: 'auto 10px auto 0'
  }

  const actionButtonStyle: React.CSSProperties = {
    textAlign: 'right'
  }

  const applyButtonStyle: React.CSSProperties = {
    marginRight: '10px'
  }

  // #endregion スタイル

  // #region イベント

  const onAfterOpenModal = () => {
    if (editUuid !== '') {
      if (!editItem) {
        return
      }
      category.current = itemListJson.itemShop.find((s) => s.name === editItem.name)?.category ?? 0
      dispatch({})
    }
  }

  const onChangeCategory = (e: React.ChangeEvent<HTMLSelectElement>) => {
    category.current = parseInt(e.target.value, 10)
    dispatch({})
  }

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = new FormData(e.currentTarget)
    const name = (form.get('itemSelect') as string) || ''
    const count = parseInt(form.get('itemCount') as string, 10)
    if (editUuid === '') {
      selectedItem.add(name, count)
    } else {
      selectedItem.applyChange(editUuid, name, count)
    }
    category.current = 0
    closeModal()
  }

  const onClickCancel = () => {
    category.current = 0
    closeModal()
  }

  // #endregion イベント

  return (
    <Modal isOpen={isOpen} style={modalStyle} ariaHideApp={false} onAfterOpen={onAfterOpenModal}>
      {editUuid === '' ? (
        <h1 style={headerStyle}>アイテム追加</h1>
      ) : (
        <h1 style={headerStyle}>アイテム編集</h1>
      )}
      <main style={mainStyle}>
        カテゴリー：
        <select style={pulldownStyle} value={category.current} onChange={onChangeCategory}>
          {Object.values(itemCategoryList.itemCategories).map((s, i) => (
            <option key={`${i}_${s}`} value={i}>
              {s}
            </option>
          ))}
        </select>
        <form onSubmit={onSubmitForm}>
          アイテム：
          <div style={targetFormsStyle}>
            {itemListJson.itemShop
              .filter((s) => s.category == category.current)
              .map((s) => (
                <div key={s.name}>
                  <input
                    type='radio'
                    id={s.name}
                    name='itemSelect'
                    value={s.name}
                    required
                    defaultChecked={editItem?.name === s.name}
                  />
                  <label htmlFor={s.name}>{`${s.name}（${s.price}G）`}</label>
                </div>
              ))}
          </div>
          <br />
          個数：
          <input
            type='number'
            name='itemCount'
            style={textBoxStyle}
            min={1}
            max={99}
            required
            defaultValue={editItem?.count ?? 1}
          />
          <div style={actionButtonStyle}>
            <input type='submit' style={applyButtonStyle} value={'適用'} />
            <button type='button' onClick={onClickCancel}>
              キャンセル
            </button>
          </div>
        </form>
      </main>
    </Modal>
  )
}

export { EditItemListModal }
